import { createSlice } from "@reduxjs/toolkit";

const categoriesSlice = createSlice({
  name: "categories",
  initialState: {
    currentIndex: { id: null, name: null },
  },
  reducers: {
    setCurrentIndex: (state, action) => {
      state.currentIndex = action.payload;
    },
  },
});

export const { setCurrentIndex } = categoriesSlice.actions;
export default categoriesSlice.reducer;
